/**
 * Restaurant display constants — ported from the RESTAURANT block in
 * child-theme/inc/menu-printer.php. Consumed by the print app and the public
 * menu feed header. The logo path is app-specific and lives with menu-print,
 * not here.
 */
export const RESTAURANT = {
  name: 'Le Montaigu',
  fullName: 'Le Montaigu Hôtel*** Restaurant Bar',
  tagline: 'Cuisine du terroir pyrénéen',
  location: 'Luz-Saint-Sauveur',
  hours: 'Dîner uniquement — 19h30 à 21h00',
  allergenNote:
    "Conformément au Décret n°2015-447, la liste des allergènes est disponible sur demande auprès de notre personnel. N'hésitez pas à nous signaler toute allergie ou intolérance alimentaire.",
} as const;
